var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24988 5H17.4999C18.1873 5 18.7501 5.56287 18.7501 6.24988V20C18.7501 20.6874 18.1873 21.2499 17.4999 21.2499H6.24988C5.56287 21.2499 5 20.6874 5 20V6.24988C5 5.56287 5.56287 5 6.24988 5ZM22.5001 18.7501H33.7501C34.4371 18.7501 35 19.3126 35 20V33.7501C35 34.4371 34.4371 35 33.7501 35H22.5001C21.8127 35 21.2499 34.4371 21.2499 33.7501V20C21.2499 19.3126 21.8127 18.7501 22.5001 18.7501ZM17.4999 23.75H6.24988C5.56287 23.75 5 24.3129 5 24.9999V33.7501C5 34.4371 5.56287 35 6.24988 35H17.4999C18.1873 35 18.7501 34.4371 18.7501 33.7501V24.9999C18.7501 24.3129 18.1873 23.75 17.4999 23.75ZM22.5001 5H33.7501C34.4371 5 35 5.56287 35 6.24988V15.0001C35 15.6871 34.4371 16.25 33.7501 16.25H22.5001C21.8127 16.25 21.2499 15.6871 21.2499 15.0001V6.24988C21.2499 5.56287 21.8127 5 22.5001 5Z",
    fill: "#DBE0D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.e14358e8b4db87a40f9cfff5797a4213.svg";
export { ForwardRef as ReactComponent };